// extracted by mini-css-extract-plugin
export var navbarSubLink = "V_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "V_ym d_f0 d_dB";
export var subPageLink = "V_gf d_gf";
export var burger = "V_yq";
export var sublinkSize = "V_yr";
export var linkSize = "V_ys";
export var Link = "V_wv K_wv K_vQ K_v8";